import React from 'react'
import './Loading.scss'
const Loading = () => {

    return (
        <div className="Loading">
            <div className="wrapper">
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="shadow"></div>
                <div className="shadow"></div>
                <div className="shadow"></div>
            </div>           
             </div>
    )
}

export default Loading